/* ARIELLE v36: thumbnail rail, keyboard-accessible arrows, touch swipe and variant media sync. */
(function(){
  function setActive(gallery,thumb){
    gallery.querySelectorAll('[data-ar-thumb]').forEach(function(item){
      var active=item===thumb;
      item.classList.toggle('is-active',active);
      item.setAttribute('aria-pressed',active?'true':'false');
    });
  }
  function showThumb(gallery,thumb){
    if(!gallery||!thumb)return;
    var hero=gallery.querySelector('.ar-product-v10__hero-image');
    var src=thumb.getAttribute('data-image-src');
    if(!hero||!src)return;
    hero.src=src;
    hero.removeAttribute('srcset');
    hero.removeAttribute('sizes');
    hero.alt=thumb.getAttribute('data-image-alt')||hero.alt;
    setActive(gallery,thumb);
  }
  function navigate(gallery,direction){
    var thumbs=Array.prototype.slice.call(gallery.querySelectorAll('[data-ar-thumb]:not([hidden])'));
    if(thumbs.length<2)return;
    var current=thumbs.findIndex(function(item){return item.classList.contains('is-active');});
    if(current<0)current=0;
    var next=(current+direction+thumbs.length)%thumbs.length;
    showThumb(gallery,thumbs[next]);
    if(thumbs[next].scrollIntoView)thumbs[next].scrollIntoView({block:'nearest',inline:'nearest',behavior:'smooth'});
  }
  document.querySelectorAll('[data-ar-gallery]').forEach(function(gallery){
    var photo=gallery.querySelector('.ar-product-v10__main-photo');
    var thumbs=gallery.querySelectorAll('[data-ar-thumb]');
    if(!photo||thumbs.length<2)return;
    var previous=document.createElement('button');
    previous.type='button';previous.className='ar36-gallery-control ar36-gallery-control--prev';
    previous.setAttribute('aria-label','Vorheriges Produktbild');previous.innerHTML='&#8592;';
    var next=document.createElement('button');
    next.type='button';next.className='ar36-gallery-control ar36-gallery-control--next';
    next.setAttribute('aria-label','Nächstes Produktbild');next.innerHTML='&#8594;';
    photo.appendChild(previous);photo.appendChild(next);
    previous.addEventListener('click',function(){navigate(gallery,-1);});
    next.addEventListener('click',function(){navigate(gallery,1);});
    var startX=null;
    photo.addEventListener('touchstart',function(event){
      if(event.touches&&event.touches.length===1)startX=event.touches[0].clientX;
    },{passive:true});
    photo.addEventListener('touchend',function(event){
      if(startX===null||!event.changedTouches||!event.changedTouches.length)return;
      var delta=event.changedTouches[0].clientX-startX;
      if(Math.abs(delta)>45)navigate(gallery,delta<0?1:-1);
      startX=null;
    },{passive:true});
  });
  document.addEventListener('click',function(event){
    var choice=event.target.closest('[data-ar-choice]');
    if(!choice)return;
    var group=choice.closest('[data-ar-option-group]');
    if(!group||!/^(farbe|color|colour)$/i.test(group.getAttribute('data-ar-option-name')||''))return;
    var form=choice.closest('form.ar-product-v10__form');
    var gallery=document.querySelector('[data-ar-gallery]');
    if(!form||!gallery)return;
    var data=form.querySelector('[data-ar-variant-data]');
    var hero=gallery.querySelector('.ar-product-v10__hero-image');
    if(!data||!hero)return;
    var variants=[];
    try{variants=JSON.parse(data.textContent);}catch(error){return;}
    var selected=Array.prototype.map.call(form.querySelectorAll('[data-ar-option-group]'),function(optionGroup){
      var selectedChoice=optionGroup.querySelector('[data-ar-choice].is-selected');
      return selectedChoice?selectedChoice.getAttribute('data-ar-option-value'):'';
    });
    var variant=variants.find(function(item){
      return Array.isArray(item.options)&&item.options.length===selected.length&&item.options.every(function(value,index){return value===selected[index];});
    });
    if(!variant||!variant.featured_image||!variant.featured_image.src)return;
    hero.src=variant.featured_image.src;
    hero.removeAttribute('srcset');hero.removeAttribute('sizes');
    hero.alt=(document.querySelector('.ar-product-v10__details h1')||{}).textContent+' – '+selected[0];
    var imageId=String(variant.featured_image.id||'');
    var target=null;
    gallery.querySelectorAll('[data-ar-thumb]').forEach(function(thumb){
      if(imageId&&thumb.getAttribute('data-image-id')===imageId)target=thumb;
    });
    if(target){setActive(gallery,target);}
  });
})();
